import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Star: FC<IconSvgProps> = ({ color, clss }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" className={clss}>
            <g fill={color}>
                <path d="M10.672.064a.879.879 0 0 0-.467.465l-2.79 6.416-6.673.979a.877.877 0 0 0-.701.618.886.886 0 0 0 .233.91l4.953 4.63-1.283 6.887h.001a.877.877 0 0 0 .334.875.816.816 0 0 0 .91.034l5.85-3.554 5.88 3.277a.823.823 0 0 0 .907-.08.911.911 0 0 0 .326-.887l-1.335-6.828 4.914-4.86v-.002a.912.912 0 0 0 .227-.918.83.83 0 0 0-.702-.585l-6.68-.666-2.84-6.283A.823.823 0 0 0 11.001 0a.825.825 0 0 0-.329.064z" />
            </g>
        </svg>
    );
};

export default Star;
